import React, { useEffect, Fragment, useState } from 'react'
import { Autocomplete, TextField, Box, Chip, Typography, FormHelperText, Grid, IconButton, CircularProgress, Popper } from '@mui/material';
import PropTypes, { InferProps } from "prop-types";
import { Controller, useFormContext } from "react-hook-form"
import FormErrors from '../formErrors';
import { AxiosGet, IsNullOrUndefined, ResultAPI } from 'service/CommonFunction/TS_function';
import SearchIcon from '@mui/icons-material/Search';
import axios from "axios"
import qs from "qs";
import Crypto from "crypto-js";
import { i18n } from 'i18n';
import { AuthToken, currentLanguage } from 'service/CommonFunction/AxiosConfig';
const i18nField = 'common';

// import { AuthToken } from 'service/AuthConfig/AuthToken';

export default function AsyncAutoComplete({
    isClearable,
    label,
    disabled,
    name,
    prefixText,
    limitTag,
    required,
    fullWidth,
    onChange,
    onBlur,
    sUrlAPI,
    sParam,
    TextFilterCont = 1,
    multiple,
    externalErrorMessage,
    ParamUrl,
    sMethodAxios,
    textSearch = i18n(`${i18nField}.inputAsync`)
}: InferProps<typeof AsyncAutoComplete.propTypes>) {

    const {
        register,
        setValue,
        watch,
        formState: { errors, isSubmitted, touchedFields },
    } = useFormContext();

    const errorMessage = FormErrors.errorMessage(
        name,
        errors,
        touchedFields,
        isSubmitted,
        externalErrorMessage,
    );

    const [inputValue, setInputValue] = React.useState('');
    const [optionsValueAuto, setOptionsValueAuto] = React.useState([] as any);
    const [txtOption, settxtOption] = useState(textSearch) as any;

    useEffect(() => {
        setInputValue(watch(name) ? watch(name).label : "")
        if (watch(name) === null || watch(name) == undefined || watch(name) == "") {
            setOptionsValueAuto([])
        }
    }, [watch(name)])

    useEffect(() => {
        settxtOption(textSearch)
    }, [textSearch])

    useEffect(() => {
        if (inputValue === '' || inputValue === null) {
            setOptionsValueAuto([])
        }
        else {
            const source = axios.CancelToken.source();
            const paramSearch = sParam === undefined ? { "sSearch": inputValue } : { "sSearch": inputValue, "sParam": sParam };
            const paramObj = { ...ParamUrl, ...paramSearch };
            const auth_token = AuthToken.get();
            const ConfigJwt = {
                Authorization: IsNullOrUndefined(auth_token) ? "" : `Bearer ${auth_token}`,
                Accept: "application/json",
                "Content-Type": "application/json",

            };

            const newParam = sUrlAPI
            const baseUrl = process.env.REACT_APP_API_URL
            const sPathApi = `${baseUrl}api/${newParam}`
            const url = new URL(sPathApi, window.location.href);

            const sNewPath = url.origin + url.pathname + url.search;
            let sSearching = currentLanguage() == "th" ? "กำลังค้นหา" : "Searching"
            settxtOption(sSearching)
            if (sMethodAxios === "POST") {
                axios.post(sNewPath, paramObj, {
                    headers: ConfigJwt,
                    cancelToken: source.token,
                    paramsSerializer: (params) => {
                        return qs.stringify(params);
                    },
                }).then((response) => {
                    if (response.data != null && response.data.result.total > 0) {
                        setOptionsValueAuto(response.data.result.data || [])
                    }
                    else {
                        setOptionsValueAuto([])
                        let sNodata = currentLanguage() == "th" ? "ไม่พบข้อมูล" : "No option"
                        settxtOption(sNodata)
                    }
                }).catch((error) => {
                    if (axios.isCancel(error)) return;
                });
            }
            else        //GET
            {
                axios.get(sNewPath, {
                    headers: ConfigJwt,
                    params: paramObj,
                    cancelToken: source.token,
                    paramsSerializer: (params) => {
                        return qs.stringify(params);
                    },
                }).then((response) => {
                    if (response.data != null && response.data.result.total > 0) {
                        setOptionsValueAuto(response.data.result.data || [])
                    }
                    else {
                        setOptionsValueAuto([])
                        let sNodata = currentLanguage() == "th" ? "ไม่พบข้อมูล" : "No option"
                        settxtOption(sNodata)
                    }
                }).catch((error) => {
                    if (axios.isCancel(error)) return;
                });
            }

            return () => source.cancel();
        }
    }, [inputValue])



    const PopperCustom = React.useCallback((props) => {
        return <Popper
            {...props}
            placement='bottom-start'
            disablePortal={true}
            modifiers={[
                {
                    name: 'flip',
                    enabled: false,
                    options: {
                        altBoundary: true,
                        rootBoundary: 'document',
                        padding: 8,
                    },
                },
            ]}
        />;
    }, []);

    return (
        <>
            <Autocomplete
                id={name}
                {...register(name)}
                getOptionLabel={(itemOption: any) => {
                    return `${itemOption.label}`
                }}
                filterOptions={(x) => x}
                options={optionsValueAuto}
                autoComplete
                PopperComponent={PopperCustom}
                size='small'
                noOptionsText={txtOption}
                blurOnSelect
                includeInputInList
                filterSelectedOptions
                disabled={disabled}
                disableClearable={!isClearable}
                multiple={multiple}
                limitTags={limitTag}
                value={watch(name) || null}
                onChange={(event: any, newValue) => {
                    if (newValue) {
                        if (newValue.value) {
                            setValue(name, newValue != null ? newValue : undefined, { shouldValidate: true })
                            setOptionsValueAuto([]);
                        }
                    } else {
                        setValue(name, null)
                    }
                    onChange && onChange(newValue)
                }}
                onInputChange={async (event, newInputValue) => {
                    settxtOption(textSearch)
                    setInputValue(newInputValue);
                    if (newInputValue === "") {
                        setOptionsValueAuto([]);
                        return undefined;
                    } else if (newInputValue.length >= TextFilterCont) {
                        // await handleSearchChange(newInputValue);
                        // loadData(newInputValue);
                    } else {
                        setOptionsValueAuto([]);
                    }
                }}
                sx={{
                    ".MuiOutlinedInput-root": {
                        paddingRight: "10px !important"
                    },
                    ".Mui-disabled": {
                        backgroundColor: "#f1f1f1",
                        color: "#000000"

                    },
                }}
                renderInput={(params) => (
                    <TextField
                        size={"small"}
                        label={label}
                        inputRef={register(name).ref}
                        error={Boolean(errorMessage)}
                        {...params}
                        fullWidth={fullWidth}
                        required={required}
                        style={{ width: '100%' }}
                        InputProps={{
                            ...params.InputProps,
                            endAdornment: (
                                <>
                                    <IconButton
                                        style={{ padding: '0px' }}
                                        disabled={disabled}
                                    >
                                        <SearchIcon />
                                    </IconButton>
                                </>
                            )
                        }}
                        InputLabelProps={{
                            disabled: disabled || false,
                            // shrink: shrink || true,
                        }}
                        //add asterisk red
                        sx={{
                            "label.MuiInputLabel-shrink": {
                                backgroundColor: "rgba(255,255,255,0.95)",
                                top: "0px",
                            },
                            ".MuiInputLabel-outlined": {
                                top: "0px",
                            },
                            ".MuiInputLabel-asterisk": {
                                color: "red"
                            }
                        }}
                    />
                )
                }
                renderOption={(props, option: any) => {
                    return (
                        <li {...props} key={option.value}>
                            {option.label}
                        </li>
                    );
                }}
                renderTags={(tagValue, getTagProps) => {
                    return (
                        <React.Fragment>
                            {
                                tagValue.slice(0, limitTag | 1).map((option: any, index) => (
                                    <Chip {...getTagProps({ index })} label={option.label} disabled={disabled || false} />
                                ))
                            }
                        </React.Fragment>
                    )
                }}
            />
            {errors && errors[name] ? (
                <FormHelperText sx={{ color: "red" }}>
                    {errors[name].message}
                </FormHelperText>
            ) : null}
        </>
    )
}

AsyncAutoComplete.propTypes = {
    required: PropTypes.bool,
    name: PropTypes.string.isRequired,
    sUrlAPI: PropTypes.string.isRequired,
    sParam: PropTypes.string,
    label: PropTypes.string,
    hint: PropTypes.string,
    isClearable: PropTypes.bool,
    disabled: PropTypes.bool,
    multiple: PropTypes.bool,
    limitTag: PropTypes.number,
    prefixText: PropTypes.string,
    subLabel: PropTypes.string,
    autoSelect: PropTypes.bool,
    fullWidth: PropTypes.bool,
    onChange: PropTypes.any,
    onBlur: PropTypes.any,
    ParamUrl: PropTypes.any,
    TextFilterCont: PropTypes.number,
    externalErrorMessage: PropTypes.string,
    sMethodAxios: PropTypes.string,
    textSearch: PropTypes.string,
};

AsyncAutoComplete.defaultProps = {
    isClearable: true,
    required: false,
    handleRender: null,
    isFreeCreate: false,
    disabled: false,
    multiple: false,
    prefixText: "",
    subLabel: "",
    autoSelect: false,
    small: true,
    fullWidth: false,
    limitTag: 1,
    sMethodAxios: 'GET'
};